/**
 * Las condiciones del servicio técnico, escritas una sola vez.
 *
 * Viven acá porque las dicen dos lados: el talón impreso del frontend
 * (`TalonReparacion`) y la página del talón que el cliente abre desde WhatsApp
 * (`/t/:token`, en el backend). Si vivieran dos veces, un día el papel y el
 * link dirían cosas distintas, y el cliente aceptó las dos.
 */

/**
 * Las condiciones del servicio.
 *
 * Es el texto acordado con el local. NO incluye recargo por mora: se decidió no
 * aplicarlo, e imprimir una penalidad que después no se cobra desgasta el resto
 * del papel.
 */
export const CONDICIONES_TALON: ReadonlyArray<{ titulo: string; texto: string }> = [
  {
    titulo: "Diagnóstico",
    texto:
      "El ingreso a la mesa de trabajo requiere el pago del diagnóstico, que cubre el desarme, la revisión y el testeo. El plazo estimado es de 48 a 72 horas hábiles. Ese importe se toma a cuenta del total de la reparación.",
  },
  {
    titulo: "Reparación",
    texto:
      "Aprobado el presupuesto y abonado el anticipo, la reparación demora de 48 a 72 horas hábiles, sujeto a feriados, demoras de transporte y disponibilidad de repuestos. Para urgencias consultar el costo del servicio prioritario.",
  },
  {
    titulo: "Entrega",
    texto:
      "Sin excepción, el equipo se entrega con el total abonado. Los precios cotizados en dólares se abonan al tipo de cambio del día del pago.",
  },
  {
    titulo: "Garantía",
    texto:
      "Las reparaciones con repuestos originales tienen 90 días de garantía. Los equipos que se devuelven sin reparar no tienen garantía. Los trabajos realizados con repuestos genéricos, cuando el cliente lo autoriza, se entregan sin garantía. La garantía se anula si el equipo presenta golpes, humedad, mal uso, sellos violentados o intervención de terceros.",
  },
  {
    titulo: "Información",
    texto:
      "No nos responsabilizamos por la pérdida de datos. Es responsabilidad del cliente entregar el equipo con una copia de seguridad previa.",
  },
  {
    titulo: "Retiro",
    texto:
      "Pasados 90 días corridos desde la fecha de cotización sin que el equipo sea retirado, se considerará abandonado y pasará a desarme.",
  },
];

export const ACEPTACION_TALON =
  "La recepción de esta constancia o la entrega del equipo implica la aceptación total de estas bases y condiciones.";
